// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kLjm","col":"styles_col__1ctHd","actions":"styles_actions__31LqR","conflict":"styles_conflict__2L5iK"};